/* eslint-disable import/no-extraneous-dependencies */
// These must be the first lines in src/index.js
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import registerServiceWorker from './registerServiceWorker';
import * as Sentry from '@sentry/browser';
import App from './App';

// eslint-disable-next-line no-unused-expressions
import('./index.css');

Sentry.init({dsn: "https://c45a83f18dd94b658d196412ca9b3ba0@sentry.io/4089238"});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

registerServiceWorker();
